import type { ClaimTask } from '../../types/task'

// MC1's status is the single fact behind two questions: which tasks count as pending,
// and which ones the card may put on hold. Trimmed as well as lower-cased — the casing
// comes straight from the stored proc, and the padding MC1 adds is only stripped at the
// API boundary, which this must not depend on.
export function isTaskOpen(task: ClaimTask): boolean {
  return task.status.trim().toLowerCase() === 'open'
}

// Native date inputs need yyyy-mm-dd. Parsed in UTC to match formatTaskDate, so
// the value shown in the input never drifts a day from the value beside it.
// A task with no hold date yet yields '', which compares unequal to any pick.
export function toDateInputValue(value: string | null | undefined): string {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toISOString().slice(0, 10)
}

// A date as yyyy-mm-dd, read from local time, not UTC: it is the user's calendar day
// that counts, and toISOString would roll it over early (or late) for anyone away
// from Greenwich.
function toLocalDateInputValue(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

// Today as yyyy-mm-dd. The on-hold proc requires a hold date later than today, so
// this is the latest day the card declines.
export function todayDateInputValue(): string {
  return toLocalDateInputValue(new Date())
}

// Tomorrow as yyyy-mm-dd, the earliest hold date the user may pick. setDate rolls
// over month and year ends on its own.
export function tomorrowDateInputValue(): string {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return toLocalDateInputValue(tomorrow)
}
